import { jsx as _jsx } from "react/jsx-runtime";
import { InputText } from '@dixa/lib-shared-habla';
import { forwardRef, useCallback, useEffect, useState, } from 'react';
/** Represents a search input for filtering the categories. */
export const CategorizedListSearch = forwardRef(function CategorizedListSearch({ value: initialValue = '', setIsSearchFocused, onSearchChange }, ref) {
    const [value, setValue] = useState(initialValue);
    /** Handles changing the search. */
    const handleSearchChange = useCallback((event) => {
        const { value } = event.target;
        setValue(value);
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(value);
    }, [onSearchChange]);
    useEffect(() => setValue(initialValue), [initialValue]);
    return (_jsx(InputText, { ref: ref, icon: "search", placeholder: "Search", value: value, onFocus: () => setIsSearchFocused(true), onBlur: () => setIsSearchFocused(false), onChange: handleSearchChange }));
});
